module.exports = __webpack_public_path__ + "static/media/dtron304ru.df768834.pdf";